<div appResizable [resizableDirections]="['top']" [resizable]="!collapsed" [maxHeight]="500" [clickElementId]="'co-pilot-hidden-button'" class="panel-container" [style.height.px]="panelHeight" [style.min-height.px]="panelMinHeight">
	<div *ngIf="(isLinked$|async) === false" class="tab-panel">
		<div style="display: flex; width: 100%; height: 100%;">
			<div (click)="linkOpenAi()" style="cursor:pointer; display: flex; justify-content: center; align-items: center; height: 100%; padding:0 20px;">
				<div style="display: flex; gap: 10px;">
					<img src="/assets/images/co-pilot.svg" alt="co-pilot logo" />
					<span>Setup CoPilot</span>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="(isLinked$|async)" class="tab-panel">
		<div style="display: flex; width: 100%; height: 100%;">
			<div (click)="collapsePanel()" class="tab-panel-icon-container" style="cursor: pointer; display: flex; justify-content: center; align-items: center; height: 100%; padding:0 20px">
				<div style="display: flex; gap: 10px;">
					<div id="bottom-panel-toggle" class="tab-panel-icon tab-panel-expand-icon">
						<div *ngIf="!collapsed" class="fa-duotone fa-chevrons-down toggle-arrow"></div>
						<div *ngIf="collapsed" class="fa-duotone fa-chevrons-up toggle-arrow"></div>
					</div>
				</div>
			</div>
			<div [ngClass]="{'current-tab': currentTab$() === 'co-pilot'}" (click)="go('co-pilot')" style="cursor: pointer; display: flex; justify-content: center; align-items: center; height: 100%; padding:0 20px;">
				<div style="display: flex; gap: 10px;">
					<img src="/assets/images/co-pilot.svg" alt="co-pilot logo" />
					<span>Ask CoPilot</span>
				</div>
			</div>
			<div [ngClass]="{'current-tab': currentTab$() === 'summary'}" (click)="go('summary')" style="cursor: pointer; display: flex; justify-content: center; align-items: center; height: 100%; padding:0 20px">
				<div style="display: flex; gap: 10px;">
					<img src="/assets/images/co-pilot.svg" alt="co-pilot logo" />
					<span>Summary</span>
				</div>
			</div>
		</div>
		<div *ngIf="currentTab$() === 'summary'" style="display: flex; justify-content: center; align-items: center; height: 100%; cursor: pointer;">
			<div style="display: flex; gap: 10px;">
				<button [matTooltip]="promptTooltip" [matMenuTriggerFor]="summaryPromptMenu" style="background: initial; margin-right:5px;" mat-flat-button class="settings-button">
					<div style="display: flex; align-items: center; gap:10px;">
						<div class="fad fa-input-text settings-icon"></div>
						<span style="font-size: 11px; max-width:125px; display: inline-block; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{summaryPrompt ? summaryPrompt.title : 'Select Prompt'}}</span>
					</div>
				</button>
			</div>
		</div>
		<mat-menu #summaryPromptMenu>
			<div *ngIf="summaryPrompts?.length > 0">
				@for (prompt of summaryPrompts; track prompt) {
				<menu mat-menu-item (click)="selectSummaryPrompt(prompt)">
					<div style="display: flex; justify-content: left; align-items: center; font-size:11px; padding-top: 8px;padding-bottom: 8px;">
						<div>{{prompt.fullPrompt}}</div>
					</div>
				</menu>
				}
			</div>
			<div *ngIf="summaryPrompts?.length === 0">
				<menu mat-menu-item disabled>
					<div style="display: flex; justify-content: left; align-items: center; font-size:11px">
						<div>No summary prompt available</div>
					</div>
				</menu>
			</div>
		</mat-menu>
		<div style="display: flex; justify-content: center; align-items: center; height: 100%; cursor: pointer;">
			<div style="display: flex; gap: 10px;">
				<button matTooltip="Manage Prompt" style="background: initial; margin-right:5px;" mat-flat-button (click)="openPromptSetting()" class="settings-button">
					<div class="fad fa-cogs settings-icon"></div>
				</button>
			</div>
		</div>
	</div>
	<div *ngIf="!collapsed" class="interaction-container">
		@switch (currentTab$()){
		@case ('co-pilot') {
		<lex-ai-single-doc-prompt *ngIf=" (isLinked$|async)"></lex-ai-single-doc-prompt>
		}
		@case ('summary') {
		<lex-doc-viewer-summary *ngIf="(isLinked$|async)" [summaryPromptId]="summaryPromptId" [summaryPrompts]="summaryPrompts"></lex-doc-viewer-summary>
		}
		}
	</div>
	<div style="flex-shrink: 0; width: 100%; text-align: center; padding: 8px;">
        <span style="font-size: 10px;">
            LLMs can produce inaccurate statements. We encourage human validation of LLM-generated responses.
        </span>
    </div>
</div>